module.exports = __webpack_public_path__ + "img/loading_test_2.4cd2f58c.png";